// ThemeTweaksBridge — apply the saved theme at app start.
//
// `useTweaks()` writes the active theme onto :root (`--primary`,
// `--color-primary`, the font, the page background) from inside its own
// effect. Until this component existed, the ONLY things mounting that hook
// were the Settings screen and the tweaks panel — so on an ordinary page load
// nothing applied the theme at all, and every @fluxora/ui Button fell back to
// the stylesheet's default primary. Opening Settings once "fixed" the colours
// for that session, which is exactly the kind of bug that gets reported as
// "the button is blue sometimes".
//
// Renders nothing: it exists for the effect, mirroring AuthStoreBridge.

import { useTweaks } from './useTweaks';

export function ThemeTweaksBridge(): null {
  useTweaks();
  return null;
}
